import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type LegalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-1">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div key="backdrop" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
        backgroundColor: 'rgba(20, 10, 4, 0.75)'
      }} onClick={onClose} aria-hidden="true" data-id="element-2" />

          {/* Modal card */}
          <motion.div key="modal" role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" initial={{
        opacity: 0,
        scale: 0.94,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.94,
        y: 16
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-3">
            <div className="relative w-full max-w-2xl max-h-[88vh] flex flex-col rounded-2xl shadow-2xl pointer-events-auto" style={{
          backgroundColor: '#FDF6EC'
        }} data-id="element-4">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-5 border-b flex-shrink-0" style={{
            borderColor: '#E8C99A'
          }} data-id="element-5">
                <h2 id="legal-modal-title" style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(1.2rem, 3vw, 1.6rem)',
              fontWeight: 700,
              color: '#2D1B0E'
            }} data-id="element-6">
                  {title}
                </h2>
                <button onClick={onClose} className="flex-shrink-0 ml-4 w-9 h-9 rounded-full flex items-center justify-center transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500" style={{
              backgroundColor: '#FFF3E6',
              color: '#5C3D1E'
            }} aria-label="Cerrar" data-id="element-7">
                  <XIcon className="w-5 h-5" data-id="element-8" />
                </button>
              </div>

              {/* Scrollable content */}
              <div className="overflow-y-auto px-6 py-6 flex-1" style={{
            fontFamily: "'Lato', sans-serif",
            color: '#5C3D1E',
            fontSize: '0.95rem',
            lineHeight: 1.75
          }} data-id="element-9">
                {children}
              </div>

              {/* Footer */}
              <div className="px-6 py-4 border-t flex-shrink-0 text-center" style={{
            borderColor: '#E8C99A'
          }} data-id="element-10">
                <button onClick={onClose} className="inline-block px-6 py-2 rounded-full text-sm font-bold text-white transition-transform hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500" style={{
              background: 'linear-gradient(135deg, #D4A017, #E8890C)'
            }} data-id="element-11">
                  Cerrar
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}